import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";

export default function Privatnost() {
    return (
        <div className="relative bg-white">
            <Header />
            <Hero title="Pravila o zaštiti privatnosti" subtitle="" />
            <article className="mt-16 mb-32 max-w-screen-lg mx-auto px-6 lg:px-0 prose prose-md space-y-5 leading-8">
                <p>
                    Ova Pravila o zaštiti privatnosti opisuju kako prikupljamo,
                    upotrebljavamo i obrađujemo vaše podatke, uključujući i
                    lične podatke, u vezi s vašim pristupom i korištenjem
                    portala &nbsp;
                    <a href="https://www.dzobs.com">www.dzobs.com</a> (u daljem
                    tekstu: "portal" ili "Dzobs").
                </p>
                <p>
                    Naše usluge ponekad sadrže linkove na usluge drugih
                    kompanija. Te kompanije imaju vlastita pravila o zaštiti
                    privatnosti i korištenju kolačića, stoga imajte na umu da će
                    informacije koje na taj način dajete, biti regulisane
                    njihovim pravilima. Svakako provjerite i njihova pravila o
                    zaštiti privatnosti, kako biste znali kako će upotrebljavati
                    vaše podatke.
                </p>
                <p>
                    Mi smo veoma predani čuvanju informacija o vama i vašoj
                    porodici. Naš tim poduzima sve razumne napore kako bismo
                    brinuli o vašoj informacijskoj sigurnosti i privatnosti.
                    Istovremeno, nijedna usluga odnosno razmjena informacija
                    putem Interneta nije potpuno sigurna. To je razlog zbog
                    kojeg ne možemo garantovati sigurnost svih ličnih podataka
                    koje dostavite (naročito dok su ti podaci još u tranzitu),
                    zbog čega je važno da razumijete da učitavanje takvih
                    podataka vršite na vlastitu odgovornost. Ako imate razloga
                    da mislite da su vaš korisnički račun ili lični podaci
                    izloženi riziku, na primjer ako je neko mogao saznati vašu
                    lozinku, odmah nam se javite, putem mail adrese
                    info@dzobs.com.
                </p>
                <p>
                    Popunjavanjem naših obrazaca za registraciju ili ponovljenim
                    korištenjem naših usluga, pristajete na korištenje vaših
                    ličnih podataka u skladu s ovim pravilima.
                </p>
                <p>
                    Kontrolor podataka je računarsko programiranje "Dzobs.com"
                    Nikola Novaković s.p. Banja Luka.
                </p>
                <p>
                    <h3>1. PODACI KOJE PRIKUPLJAMO</h3>
                </p>
                <p>
                    Postoje tri opšte kategorije informacija koje prikupljamo.
                </p>
                <p>
                    <strong>1.1 Informacije koje nam dajete</strong>
                </p>
                <p>1.1.1 Informacije potrebne za korištenje portala</p>
                <p>
                    Kada se registrujete kao korisnik portala odnosno kada
                    koristite našu web stranicu prikupljamo određene lične
                    podatke o vama. Ove informacije se koriste kako bi smo vam
                    pružali usluge pregleda kataloga poslova i druge usluge,
                    radi provođenja marketinških aktivnosti, kao i radi analize
                    načina na koji posjetioci koriste našu web stranicu i
                    aplikaciju.
                </p>
                <p>
                    <strong>Informacije za otvaranje korisničkog računa</strong>{" "}
                    - kada se prijavite kao korisnik portala, prikupljamo
                    informacije kao što su: vaše ime, prezime i adresa e-pošte.
                    U određenim slučajevima i u ograničenom obimu prikupljamo
                    podatke sa vaših profila na društvenim mrežama (ukoliko se
                    putem tih profila prijavljujete kao korisnik portala).
                </p>
                <p>
                    <strong>
                        Komunikacije s portalom i ostalim korisnicima portala
                    </strong>
                    - kada komunicirate s ovlaštenim osobama portala ili
                    koristite stranicu Dzobs a za komunikaciju s drugim
                    korisnicima, prikupljamo informacije o vašoj komunikaciji i
                    svim informacijama koje ste na taj način odlučili pružiti.
                </p>
                <p>1.1.2 Podaci koje ste nam poslali</p>
                {/* <p>
                    Možete nam poslati i neke dodatne lične podatke kako bismo
                    uspostavili mogućnost za bolji korisnički doživljaj odnosno
                    personalizirali naše usluge u odnosu na vas. Ove se dodatne
                    informacije obrađuju na temelju vašeg pristanka.
                </p>
                <p>
                    <strong>Dodatne informacije o korisničkom računu</strong> -
                    možete odabrati da dostavite dodatne informacije, kao dio
                    vašeg korisničkog računa (kao što su pol, željeni jezik,
                    grad i lični opis). Neke od tih informacija navedenih u
                    postavkama računa mogu u budućnosti biti javno vidljive
                    drugima.
                </p>
                <p>
                    <strong>Drugi podaci</strong> - možete nam dati i druge
                    informacije, prilikom popunjavanja obrazaca, provođenja
                    pretraživanja, ažuriranja ili dodavanja informacija vašem
                    korisničkom računu, odgovaranja na ankete, objavljivanja na
                    forumima, sudjelovanja u promocijama ili korištenja drugih
                    mogućnosti portala. Također, možete odabrati opciju da
                    primate notifikacije na vašem uređaju. Takve notifikacije
                    možete podešavati u postavkama aplikacije.
                </p> */}
                <p>
                    Propisi Evropske unije, kao i domaći propisi, utvrđuju
                    posebna pravila za obrađivanje "posebnih kategorija ličnih
                    podataka", koji uključuju rasno, nacionalno ili etničko
                    porijeklo, političko mišljenje ili stranačku pripadnost,
                    religijsko ili drugo uvjerenje, te zanimaju li vas muškarci
                    ili žene. Dopuštamo vam da takve podatke objavite, kako bi
                    ih mogli vidjeti ljudi koje vi odaberete (što može
                    uključivati i sve posjetioce našeg portala). Mi takve
                    podatke generalno ne obrađujemo osim u slučaju kada vi
                    odaberete da dodate takve podatke odnosno učinite ih
                    dostupnim drugima.
                </p>
                <p>
                    Kada objavljujete iskustva o kompanijama, vaše korisničko
                    ime je zaštićeno i nije javno vidljivo, dok je sadržaj
                    objavljenog iskustva vidljiv svim posjetiocima portala. Mi
                    nismo odgovorni za način na koji druge osobe koriste sadržaj
                    objavljenih iskustava. Preporučujemo da u sadržaju iskustva
                    izbjegavate dijeljenje ličnih podataka, a posebno
                    informacije koje se mogu koristiti za neposredno
                    identifikovanje, kao što su vaše ime, dob, adresa i ime
                    poslodavca. Nismo odgovorni za privatnost identifikacijskih
                    informacija koje objavite u sadržaju iskustva.
                </p>
                <p>
                    <strong>
                        1.2 Informacije koje automatski prikupljamo prilikom
                        vašeg korištenja portala
                    </strong>
                </p>
                <p>
                    Kada koristite portal, automatski prikupljamo neke
                    informacije, uključujući lične podatke, o uslugama koje
                    koristite i načinu na koji ih upotrebljavate. Ove
                    informacije potrebne su za odgovarajuće izvršenje ugovora
                    između vas i nas, kako bismo postupali u skladu sa našim
                    pravnim i zakonskim obvezama i imajući u vidu naš legitiman
                    interes za pružanje i poboljšanje usluga portala.
                </p>
                <p>
                    <strong>Informacije o geografskoj lokaciji</strong> - kada
                    koristite određene usluge portala, možemo prikupiti
                    informacije o vašoj preciznoj ili približnoj lokaciji, kako
                    je ona određena podacima poput vaše IP adrese ili GPS-a
                    mobilnog uređaja. Većina mobilnih uređaja omogućuje vam da
                    upravljate ili onemogućite upotrebu usluga lokacije za
                    aplikacije, u izborniku postavki uređaja. Portal može
                    prikupljati te podatke čak i kada ne upotrebljavate
                    aplikaciju, ako je ta veza omogućena putem vaših postavki
                    ili dozvola za uređaj.
                </p>
                <p>
                    <strong>Informacije o načinu korištenja portala</strong> -
                    prikupljamo informacije o vašim interakcijama putem portala,
                    kao što su stranice ili sadržaj koji pregledavate,
                    pretraživanja za ispis i druge radnje na portalu.
                </p>
                <p>
                    <strong>Zapisnik podataka i podataka o uređaju</strong> -
                    automatski prikupljamo podatke o zapisima i podatke o
                    uređaju, kada pristupate i koristite portal, čak i ako niste
                    otvorili korisnički račun ili niste prijavljeni. Ti podaci
                    uključuju, između ostalog, pojedinosti o tome kako ste
                    koristili portal (uključujući korištenje linkova na web
                    stranice odnosno aplikacije trećih strana), IP adresu
                    (numerički kod za identificiranje vašeg uređaja koji može
                    sadržati informacije o zemlji, regionu, gradu i adresi na
                    kojoj se nalazite), datume i vremena pristupa, podatke o
                    hardveru i softveru, informacije o uređaju, jedinstvene
                    identifikatore i podatke o kolačićima.
                </p>
                <p>
                    <strong>Kolačići i slične tehnologije</strong> - koristimo
                    kolačiće i druge slične tehnologije, kao što su
                    web-svjetionici, pikseli i identifikatori mobilnih uređaja.
                    Možemo dopustiti i našim poslovnim partnerima da koriste ove
                    tehnologije praćenja na portalu ili angažovati druge da u
                    naše ime prate vaše ponašanje u vezi sa korištenjem naše web
                    stranice i aplikacije. Više informacija o našoj upotrebi
                    ovih tehnologija potražite u našim pravilima o kolačićima.
                </p>
                <p>
                    <strong>
                        1.3 Informacije koje prikupljamo od trećih strana
                    </strong>
                </p>
                <p>
                    Porta može prikupljati informacije, uključujući i lične
                    podatke, koje drugi pružaju o vama, kada koriste portal ili
                    dobijaju informacije iz drugih izvora i kombinuju ih s
                    informacijama koje prikupljamo putem portala. Ne
                    kontrolišemo, ne nadziremo i ne odgovaramo za način na koji
                    treće osobe koje pružaju vaše podatke obrađuju te podatke, a
                    bilo koji zahtjev za informacijama o otkrivanju vaših
                    osobnih podataka treba uputiti trećim stranama.
                </p>
                <p>
                    <strong>Usluge treće strane</strong> - ako povezujete,
                    povežete se ili se prijavite na portal putem usluga treće
                    strane (npr. Google, Facebook), treća strana može nam
                    poslati podatke kao što su registracijske i informacije o
                    profilu te usluge. Ove informacije variraju i kontrolisane
                    su od treće strane ili su na to ovlašteni putem vaših
                    postavki privatnosti u toj usluzi.
                </p>
                <p>
                    <strong>Ostali izvori</strong> - u opsegu dopuštenom
                    primjenjivim zakonima, možemo primiti dodatne informacije o
                    vama, kao što su demografski podaci ili podaci potrebni za
                    otkrivanje prevara, od pružatelja usluga trećih strana i/ili
                    partnera te ih kombinovati s našim podacima o vama. Možemo
                    primati informacije o vašim iskustvima i interakcijama s
                    našim partnerskim oglasnim mrežama.
                </p>
                <p>
                    <h3>2. KAKO KORISTIMO INFORMACIJE KOJE PRIKUPLJAMO</h3>
                </p>
                <p>
                    Upotrebljavamo, pohranjujemo i obrađujemo informacije,
                    uključujući i lične podatke, u svrhe boljeg razumijevanja
                    vaših interesa i preferencija, poboljšanja i razvoja
                    portala, mjerenja i poboljšanja oglašavanja i marketinga,
                    stvaranja i održavanja pouzdane i sigurnije okoline te sa
                    svrhom ostvarivanja naših pravnih i zakonskih obveza,
                    uključujući i sljedeće:
                </p>
                <p>
                    <strong>
                        2.1 Pružanje usluga, poboljšanje i razvoj portala
                    </strong>
                </p>
                <ul>
                    <li>Omogućujemo vam pristup i korištenje portala;</li>
                    <li>Omogućujemo vam komuniciranje s drugim korisnicima;</li>
                    <li>
                        Djelujemo, štitimo, poboljšavamo i optimizujemo portal i
                        vaše korisničko iskustvo, na primjer obavljanjem analiza
                        i provođenjem istraživanja;
                    </li>
                    <li>Pružamo vam korisničku podršku;</li>
                    <li>
                        Šaljemo vam poruke o uslugama ili korisničkoj podršci,
                        ažuriranja, sigurnosna upozorenja i obavijesti o računu;
                    </li>
                    <li>
                        Da bismo bili u mogućnosti pružati kvalitetnu uslugu,
                        zaštititi, poboljšati i optimizovati portal, te
                        personalizovati i prilagoditi vaše korisničko iskustvo
                        (kao što su prijedlozi za unos ili rangiranje rezultata
                        pretraživanja), možemo provoditi profiliranje na temelju
                        vaših interakcija s portalom, istorije pretraživanja i
                        provedenih kupovina, podataka o vašem profilu i
                        postavkama te drugih sadržaja koji ste poslali portalu;
                    </li>
                </ul>
                <p>
                    Obrađujemo ove informacije s obzirom na naš zakonski odnosno
                    legitimni interes za funkcioniranje i poboljšanje portala i
                    iskustva naših korisnika, bolje razumijevanja naših
                    korisnika, promociju naših usluga i upravljanje našom web
                    stranicom i aplikacijama sa ciljem efikasnog kreiranja,
                    publiciranja i distribuiranja vijesti, medijskog i drugog
                    vezanog žurnalističkog sadržaja, kao i kada je to potrebno
                    radi odgovarajuće provedbe ugovora s vama.
                </p>
                <p>
                    <strong>
                        2.2 Stvaranje i održavanje pouzdanog i sigurnijeg
                        okruženja
                    </strong>
                </p>
                <ul>
                    <li>
                        Otkrivanje i sprečavanje prijevara, neželjene pošte,
                        zloupotrebe, sigurnosnih incidenata i drugih štetnih
                        aktivnosti;
                    </li>
                    <li>Provodimo sigurnosne istrage i procjenu rizika;</li>
                    <li>
                        Provodimo provjeru podataka ili identifikacijskih
                        podataka;
                    </li>
                    <li>Pridržavamo se naših zakonskih obveza;</li>
                    <li>Provedimo naša Pravila korištenja i druga pravila;</li>
                    <li>
                        U vezi s gore navedenim aktivnostima, možemo provesti
                        profiliranje na temelju vaših interakcija s portalom,
                        vašim informacijama o korisničkom računu i ostalim
                        sadržajima koje dostavite portalu te na temelju
                        informacija dobijenih od trećih strana. U ograničenim
                        slučajevima, automatizovani procesi mogu ograničiti ili
                        obustaviti pristup portalu, ako takvi procesi otkriju
                        korisnika ili aktivnosti za koje smatramo da
                        predstavljaju sigurnosni ili drugi rizik za portal,
                        druge korisnike ili treće strane.
                    </li>
                </ul>
                <p>
                    Ove informacije obrađujemo s obzirom na naš zakoniti odnosno
                    legitimni interes u zaštiti portala, kako bismo mjerili
                    adekvatno sprovođenje naših obveza prema vama i u skladu s
                    primjenjivim zakonima.
                </p>
                <p>
                    <strong>
                        2.3 Pružanje, prilagodba, mjerenje i poboljšanje
                        oglašavanja i marketinga
                    </strong>
                </p>
                <ul>
                    <li>
                        Šaljemo vam promotivne poruke, oglase i druge
                        informacije koje bi vam mogle biti od interesa na
                        temelju vaših preferencija (uključujući informacije o
                        najnovijim vijestima, portalu ili partnerskim kampanjama
                        i uslugama) i oglase društvenih mreža, putem platformi
                        društvenih mreža, kao što su Facebook ili Google, ili
                        putem naših partnera u oglašavanju;
                    </li>
                    <li>
                        Prilagođavamo, mjerimo i poboljšavamo naše oglašavanje;
                    </li>
                    <li>
                        Upravljamo programima preporuka, nagradama, anketama,
                        nagradnim igrama, takmičenjima ili drugim promotivnim
                        aktivnostima ili događajima, koje sponzoriše ili kojima
                        upravlja portal, njegovi partneri ili treće strane.;
                    </li>
                    <li>
                        Provodimo profilisanje vaših osobina i preferencija (na
                        temelju informacija koje ste nam dali, vaše interakcije
                        s portalom, informacija dobivenih od trećih strana i
                        vaše povijesti pretraživanja), kako bi smo vam slali
                        poruke, oglase i druge relevantne informacije za koje
                        ocijenimo da bi vam mogli biti od interesa;
                    </li>
                </ul>
                <p>
                    Obrađujemo prikupljene podatke za svrhe navedene u ovom
                    odjeljku, s obzirom na naš zakonski odnosno legitimni
                    interes za obavljanje marketinških aktivnosti, kako bismo
                    vam ponudili proizvode ili usluge koje bi mogle biti predmet
                    vaših interesa.
                </p>
                <p>
                    <strong>2.4 Kontaktiranje</strong>
                </p>
                <p>
                    Možemo upotrijebiti vaše podatke kako bismo vas kontaktirali
                    o različitim stvarima, kao što su:
                </p>
                <ul>
                    <li>
                        obavijesti o promjenama pravila portala i Uslova
                        korištenja;
                    </li>
                    <li>
                        provjere u vezi sa uslugama ili aktivnostima za koje ste
                        se prijavili;
                    </li>
                    <li>
                        odgovoriti vam kada ste nas kontaktirali ili odgovoriti
                        na vaš upit, komentar ili pritužbu;
                    </li>
                    <li>
                        slanje obavijesti na vašem uređaju ako ste takvu opciju
                        odabrali u svojim postavkama
                    </li>
                </ul>
                <p>
                    Kontaktiraćemo vas samo kada je to potrebno ili kada nam
                    date svoje dopuštenje.
                </p>
                <p>
                    <h3>3. DIJELJENJE I OTKRIVANJE</h3>
                </p>
                <p>
                    Nikada nećemo prodavati vaše osobne podatke. Dijelimo ih s
                    drugima na sljedeće načine:
                </p>
                <p>
                    <strong>3.1 Uz vašu saglasnost</strong>
                </p>
                <p>
                    Tamo gdje ste dali saglasnost, dijelimo vaše podatke,
                    uključujući i lične podatke, kako je opisano u trenutku
                    pristanka, kao što je slučaj kada ovlastite aplikaciju ili
                    web stranicu treće strane za pristup vašem Korisničkom
                    računu ili kada učestvujete u promotivnim aktivnostima koje
                    provode partneri portala ili treće strane.
                </p>
                <p>
                    <strong>3.2 Profili i druge javne informacije</strong>
                </p>
                <p>
                    Portal vam omogućuje objavljivanje informacija, uključujući
                    i lične podatke, koje su vidljive široj javnosti. Na
                    primjer:
                </p>
                <ul>
                    {/* <li>
                        Dijelovi vašeg javnog korisničkog računa na portalu kao
                        što su vaše ime, broj telefona, opis, grad i drugi
                        podaci koje se odlučite unijeti javno su vidljivi
                        drugima;
                    </li> */}
                    <li>
                        Ako pošaljete utisak o kompaniji taj sadržaj je javno
                        vidljiv, uz izuzetak zaštite vašeg korisničkog imena
                        kako je prethodno navedeno;
                    </li>
                    <li>
                        Kada nešto javno objavite, poput objavljivanja komentara
                        koje javnost može vidjeti.
                    </li>
                </ul>
                <p>
                    Informacije koje javno podijelite na portalu mogu se
                    indeksirati pomoću tražilica treće strane. U nekim
                    slučajevima možete isključiti ovu mogućnost u postavkama
                    računa. Ako promijenite postavke ili sadržaj koji se javno
                    prikazuje te tražilice možda neće ažurirati svoje baze
                    podataka. Ne kontrolišemo praksu tražilica trećih strana i
                    oni mogu koristiti spremišta koja sadrže vaše zastarjele
                    podatke.
                </p>
                <p>
                    <strong>
                        3.3 Usklađenost sa zakonom, odgovaranje na pravne
                        zahtjeve, sprječavanje štete i zaštita naših prava
                    </strong>
                </p>
                <p>
                    Portal može dostaviti vaše podatke, uključujući i lične
                    podatke, sudovima, policijskim tijelima ili vladinim
                    tijelima ili ovlaštenim trećim stranama, ukoliko smo i u
                    onoj mjeri u kojoj smo zakonski obvezani ili je to zakonski
                    dopušteno, ili ako je takvo otkrivanje razumno potrebno
                    radi: (i) udovoljavanja našim zakonskim obvezama, (ii)
                    pravnih postupaka i odgovora na zahtjeve usmjerene protiv
                    portala, (iii) odgovaranja na provjerene zahtjeve vezane za
                    kaznene istrage ili navodnu ili sumnjivu ilegalnu aktivnost
                    ili bilo koju drugu aktivnost koja nas ili naše korisnike
                    može izložiti odgovornosti za štetu, (iv) provođenja i
                    upravljanja našim Uslovima korištenja ili drugim ugovorima s
                    korisnicima, ili (v) zaštite prava, imovine ili lične
                    sigurnosti portala, njegovih zaposlenika, korisnika ili
                    članova javnosti.
                </p>
                <p>
                    Tamo gdje je to prikladno, možemo obavijestiti korisnike o
                    takvim pravnim zahtjevima, osim ako: (i) je takva obavijest
                    zabranjena sama po sebi, sudskim nalogom ili primjenjivim
                    zakonom, ili (ii) smatramo da bi obavještavanje bilo
                    uzaludno, nedjelotvorno, stvaralo rizik od povrede ili
                    tjelesne ozljede pojedincu ili grupi, ili stvaralo ili
                    povećavalo rizik od prevare prema ili našim korisnicima. U
                    slučajevima u kojima postupamo u skladu sa zakonskim
                    zahtjevima, bez prethodne obavijesti iz nekog od navedenih
                    razloga, pokušaćemo obavijestiti korisnika o zahtjevu, nakon
                    što je ispunjen i kada, u dobroj vjeri, utvrdimo da u tome
                    više nismo spriječeni.
                </p>
                <p>
                    <strong>3.4 Pružaoci usluga</strong>
                </p>
                <p>
                    Portal koristi različite pružaoce usluga i tehnologije
                    trećih strana (npr. Google, Facebook i sl.) koje nam pomažu
                    pružati usluge vezane uz portal. Neke kompanije koje nam
                    pružaju usluge nalaze se izvan Evropske unije. To dopuštamo
                    samo ako smo zadovoljni njihovim nivoom sigurnosti pri
                    zaštiti podataka. Kada nam dajete svoje podatke, imajte na
                    umu da bi se oni mogli prenijeti, pohraniti ili obrađivati
                    na lokaciji izvan EEA odnosno u državama koje ne osiguravaju
                    adekvatne mjere zaštite utvrđene BiH ili EU legislativom.
                </p>
                <p>
                    Pružamo zbirne statističke podatke i uvide koji pomažu
                    ljudima i kompanijama razumjeti kako ljudi reagiraju na
                    njihove objave, ponude, stranice i drugi sadržaj na portalu
                    i izvan njega.
                </p>
                <p>3.4.1 Oglašivači</p>
                <p>
                    Oglašivačima pružamo izvještaje o profilu osoba koje vide
                    njihove oglase i o učinku njihovih oglasa ali ne dijelimo
                    podatke koji vas lično identifikuju (podaci kao što su vaše
                    ime ili adresa e-pošte, koji se sami mogu upotrebiti kako bi
                    vas se kontaktiralo ili identificiralo) osim ako nam date
                    dopuštenje. Pružamo opšte demografske podatke i podatke koji
                    zanimaju oglašivače (na primjer, da je oglas vidjela osoba
                    koja živi u Doboju) kako bismo im pomogli bolje razumjeti
                    njihovu publiku. Takođe potvrđujemo koji su oglasi na
                    portali doveli do kupnje ili aktivnosti u vezi s
                    oglašivačem.
                </p>
                <p>3.4.2 Partneri za mjerenja </p>
                <p>
                    Dijelimo podatke o vama s društvima koja ih agregiraju kako
                    bi pružila analitička i mjerna izvješća nama i našim
                    partnerima.
                </p>
                <p>3.4.3 Prodavaoci i pružaoci usluga</p>
                <p>
                    Pružamo podatke i sadržaj prodavoacima i pružaocima usluga
                    koji podržavaju naše poslovanje, na primjer pružanjem usluga
                    tehničke infrastrukture, analizom načina upotrebe naših
                    proizvoda, pružanjem korisničke podrške, omogućavanjem
                    plaćanja ili provedbom anketa.
                </p>
                <p>3.4.4 Tijela za provedbu zakona ili pravni zahtjevi</p>
                <p>
                    Kada je to nužno radi postupanja u skladu sa odredbama
                    primjenjivih zakona i propisa, odnosno na temelju pravnih
                    zahtjeva, dijelimo vaše podatke s tijelima za provedbu
                    zakona.
                </p>
                <p>
                    <strong>3.5 Društvene mreže</strong>
                </p>
                <p>
                    Tamo gdje je dopušteno prema primjenjivom zakonu, možemo
                    koristiti određene ograničene osobne podatke o vama kako
                    bismo ih podijelili s platformama društvenih ili drugih
                    mreža, kao što su Facebook ili Google, radi generisanja
                    potencijalnih kupaca, privlačenja prometa na naše web
                    stranice ili drugog načina promivisanja naših usluga ili
                    portala uopšte. Ove se aktivnosti obrade temelje na našem
                    legitimnom interesu za obavljanje marketinških aktivnosti,
                    kako bismo vam ponudili proizvode ili usluge koji mogu biti
                    dijelom vašeg interesa.
                </p>
                <p>
                    Portal ne kontroliše niti nadzire društvene medijske
                    platforme s kojima možemo dijeliti vaše lične podatke. Stoga
                    sva pitanja o načinu na koji vaš pružaoc usluga platforme
                    društvenih medija obrađuje vaše lične podatke treba uputiti
                    takvom pružaocu usluga.
                </p>
                <p>
                    <strong>3.6 Poslovni transferi</strong>
                </p>
                <p>
                    Ako se portal obveže ili bude uključen u bilo koji postupak
                    spajanja, pripajanja, stjecanja, reorganizacije, prodaje
                    imovine ili stečajnog postupka, tada možemo prodati,
                    prenositi ili dijeliti dio ili cjelokupnu našu imovinu,
                    uključujući vaše podatke koji su vezani uz takvu transakciju
                    ili u pokušaj takve transakcije (npr. due diligence). O tome
                    ćemo vas obavijestiti prije prenosa vaših osobnih podataka i
                    prije nego što vaši osobni podaci budi podložni eventualno
                    drugačijim pravilima o zaštiti privatnosti.
                </p>
                <p>
                    <strong>3.7 Skupni podaci</strong>
                </p>
                <p>
                    Možemo takođe dijeliti agregirane/skupne informacije
                    (informacije o našim korisnicima koje kombiniramo tako da
                    više ne identificiraju ili ne referiraju na pojedinačne
                    korisnike) i druge anonimizirane informacije za regulatornu
                    usklađenost, analizu tržišta, demografsko profiliranje,
                    marketing i oglašavanje, te u druge poslove svrhe.
                </p>
                <p>
                    <h3>4. OSTALE VAŽNE INFORMACIJE</h3>
                </p>
                <p>
                    <strong>4.1 Analiza vaših komunikacija</strong>
                </p>
                <p>
                    Možemo pregledati, skenirati ili analizirati vaše
                    komunikacije na portalu ili na stranicama portala na
                    društvenim mrežama, za prevenciju prevara, procjenu rizika,
                    usklađenosti s propisima, istraživanje, razvoj proizvoda i
                    korisničku podršku. Na primjer, kao dio naših prevencijskih
                    napora, skeniramo i analiziramo poruke kako bismo zaštitili
                    podatke o kontaktima i reference na druge web stranice. U
                    nekim ćemo slučajevima možda skenirati, pregledati ili
                    analizirati poruke kako bismo ispravili, poboljšali i
                    proširili ponudu naših proizvoda odnosno usluga. Koristimo
                    automatizovane metode gdje je razumno moguće. Međutim,
                    ponekad ćemo morati ručno pregledati neke komunikacije, kao
                    što su slučajevi radi provjera prevara i korisničke podrške
                    ili kako bismo procijenili i poboljšali funkcionalnost
                    automatizovanih alata. Nećemo pregledavati, skenirati ili
                    analizirati vaše komunikacije kako bismo vam poslali
                    marketinške poruke treće strane, a nećemo niti prodavati
                    recenzije niti analize tih komunikacija.
                </p>
                <p>
                    Te se aktivnosti provode na temelju našeg legitimnog
                    interesa za osiguravanje usklađenosti s primjenjivim
                    zakonima i našim Uslovima, sprečavanje prijevara,
                    promovisanje sigurnosti i poboljšanje i osiguravanje
                    odgovarajućeg izvršenja naših usluga.
                </p>
                <p>
                    <h3>5. PARTNERI - TREĆE STRANE</h3>
                </p>
                <p>
                    Portal može sadržavati veze s web stranicama ili uslugama
                    trećih strana, kao što su integracije trećih strana ili
                    druge usluge treće strane ("partneri - treće strane").
                    Portal ne posjeduje niti kontroliše ove partnere - treće
                    strane i kada stupite u interakciju s njima, možete pružati
                    informacije izravno partnerima - trećim stranama, portalu
                    ili oboje. Ovi partneri - treće strane imat će svoja pravila
                    o prikupljanju, korištenju i otkrivanju informacija.
                    Preporučujemo da pregledate pravila o privatnosti drugih web
                    stranica koje posjećujete.
                </p>
                <p>
                    <h3>6. VAŠA PRAVA</h3>
                </p>
                <p>
                    Za sva pitanja i ostvarivanje prava navedenih u ovom
                    odjeljku možete nam se obratiti slanjem elektroničke pošte
                    na adresu info@dzobs.com. Imajte na umu da možemo od vas
                    tražiti da potvrdite svoj identitet, prije poduzimanja
                    daljnjih radnji na vaš zahtjev.
                </p>
                <p>
                    <strong>6.1 Upravljanje vašim informacijama</strong>
                </p>
                <p>
                    Možete pristupiti i ažurirati neke svoje podatke putem
                    postavki korisničkog računa. Ako ste odabrali povezivanje na
                    portal putem aplikacije treće strane, kao što je Facebook
                    ili Google, možete promijeniti postavke i ukloniti dozvolu
                    za aplikaciju mijenjanjem postavki računa. Vi ste odgovorni
                    za ažuriranje vaših ličnih podataka.
                </p>
                <p>
                    <strong>
                        6.2 Ispravak netačnih ili nepotpunih podataka
                    </strong>
                </p>
                <p>
                    Imate pravo zatražiti da ispravimo netačne ili nepotpune
                    lične podatke o vama (a koje ne možete ažurirati neposredno
                    na vašem korisničkom računu).
                </p>
                <p>
                    <strong>6.3 Zadržavanje i brisanje podataka</strong>
                </p>
                <p>
                    Period čuvanja vaših ličnih podataka ovisi o svrsi obrade,
                    kao što je navedeno u ovim pravilima o zaštiti privatnosti.
                    Na primjer, ukoliko su nam vaši podaci potrebni radi davanja
                    odgovora na vaše upite o uslugama ili proizvodima, vaše
                    lične podatke ćemo čuvati sve dok koristite naš proizvod ili
                    uslugu. Takođe, kada postoji potreba da vaše lične podatke
                    obrađujemo u računovodstvene svrhe, čuvat ćemo ih dok za to
                    postoje validni razlozi. Nakon što čuvanje odnosno obrada
                    vaših podataka više ne bude potrebno za ispunjenje svrhe u
                    koju su podaci prikupljeni i obrađivani, izbrisaćemo ih ili
                    anonimizirati uklanjanjem svih pojedinosti koje vas
                    identificiraju. Ako smo zatražili vašu saglasnost za obradu
                    vaših ličnih podataka i nemamo drugih zakonskih osnova da
                    nastavimo s obradom, a vi povučete saglasnost, izbrisat ćemo
                    vaše lične podatke. Međutim, kada se odjavite sa liste
                    primatelja marketinških poruka, zadržat ćemo vašu e-mail
                    adresu kako bismo osigurali da vam u budućnosti ne šaljemo
                    marketinški materijal.
                </p>
                <p>
                    <strong>6.4 Dostavljanje prigovora</strong>
                </p>
                <p>
                    Imate pravo podnijeti prigovor na aktivnosti obrade podataka
                    od strane portala, pred Agencijom za zaštitu osobnih
                    podataka BiH (AZOP BiH). Ukoliko se nalazite na području EU,
                    prigovor možete podnijeti nadležnim regulatornim tijelima za
                    zaštitu ličnih podataka u EU ili AZOP BiH .
                </p>
                <p>
                    <h3>7. SIGURNOST</h3>
                </p>
                <p>
                    Kontinuirano provodimo i ažuriramo administrativne, tehničke
                    i fizičke mjere sigurnosti kako bismo zaštitili vaše podatke
                    od neovlaštenog pristupa, gubitka, uništenja ili izmjene.
                    Ako znate ili imate razloga vjerovati da su vaši podaci za
                    uspostavu korisničkog računa izgubljeni, ukradeni,
                    zloupotrijebljeni ili na drugi način ugroženi ili, u slučaju
                    bilo kakve stvarne povrede ili sumnje na neovlaštenu
                    upotrebu vašeg korisničkog računa, odmah nas kontaktirajte.
                </p>
                <p>
                    <h3>8. PROMJENE OVIH PRAVILA</h3>
                </p>
                <p>
                    Portal pridržava pravo izmjene ovih Pravila o zaštiti
                    privatnosti, u bilo kojem trenutku, u skladu s ovom
                    odredbom. Ako promijenimo ova Pravila, objavićemo
                    izmijenjena Pravila o zaštiti privatnosti na web stranicama
                    i ažurirati datum zadnje izmjene. Ako se ne slažete s
                    izmijenjenom Pravilima o zaštiti privatnosti, možete
                    otkazati svoj račun. Ako ne otkažete svoj račun prije datuma
                    kada izmijenjena Pravila o zaštiti privatnosti stupaju na
                    snagu, vaš daljnji pristup i korištenje portala biće
                    podložno revidiranim Pravilima o zaštiti privatnosti.
                </p>
                <p>
                    <h3>9. KONTAKTIRAJTE NAS</h3>
                </p>
                <p>
                    Ako imate bilo kakvih pitanja ili pritužbi u vezi s ovim
                    Pravilima o zaštiti privatnosti ili našim postupcima obrade
                    vaših podataka, možete nam poslati e-poštu ili nas
                    kontaktirati na:
                </p>
                <p>
                    Računarsko programiranje "Dzobs.com" Nikola Novaković s.p.
                    Banja Luka
                    <br />
                    Boška Tošića 17
                    <br />
                    78000 Banja Luka
                </p>
                <p>e-mail: info@dzobs.com</p>
                <br />
                <p>
                    <h2>POLITIKA KORIŠTENJA KOLAČIĆA</h2>
                </p>
                <p>
                    <strong>1. Što su kolačići i tehnologije praćenja?</strong>
                </p>
                <p>
                    Kolačići (engl. cookies) su mali paketi podataka koji se
                    upotrebljavaju za pohranu i primanje anonimnih
                    identifikatora te drugih podataka o računalima, telefonima i
                    ostalim uređajima. Druge tehnologije, uključujući podatke
                    koje pohranjujemo u web-pregledniku ili na uređaju,
                    identifikatore povezane s uređajem i drugi softver, takođe
                    se upotrebljavaju se za slične svrhe. U ovim pravilima sve
                    te tehnologije nazivamo „kolačićima".
                </p>
                <p>
                    Kolačići nam pomažu pružati, zaštititi i poboljšati naše
                    proizvode, na primjer personalizacijom sadržaja,
                    prilagođavanjem i mjerenjem oglasa te omogućavanjem
                    sigurnijeg okruženja. Premda se kolačići koje upotrebljavamo
                    mogu povremeno mijenjati u skladu s poboljšanjima i
                    ažuriranjima, upotrebljavamo ih za sljedeće svrhe:
                </p>
                <ul>
                    <li>
                        kako bi se sjetili informacija o vama, tako da nam ih ne
                        morate ponovno davati;
                    </li>
                    <li>
                        kako biste mogli ostati prijavljeni, čak i na različitim
                        uređajima;
                    </li>
                    <li>
                        kako bi nam pomogli da shvatimo načine na koje ljudi
                        koriste naše usluge i kako bismo ih mogli poboljšati;
                    </li>
                    <li>da bismo zaštitili vaš korisnički račun i podatke;</li>
                    <li>
                        kolačići nam pomažu prikazivati oglase i davati
                        relevantne preporuke za poduzeća i druge organizacije
                        osobama koje bi mogle biti zainteresirane za njihove
                        proizvode, usluge ili ciljeve;
                    </li>
                    <li>
                        kako bi nam pomogli da prilagodimo i personaliziramo
                        portal, sjećajući se vaših preferencija i postavki;
                    </li>
                </ul>
                <p>
                    Podaci pohranjeni korištenjem kolačića na portalu ne sadrže
                    lične detalje iz kojih bi se mogao utvrditi identitet
                    korisnika.
                </p>
                <p>
                    Korištenje kolačića omogućava i drugim organizacijama da nam
                    pomognu pri analiziranju načina na koji se naša web stranica
                    koristi, mjerenju broja posjetilaca na našoj web stranici i
                    prikazivanja marketinškog materijala.
                </p>
                <p>
                    <strong>2. Postoje različite vrste kolačića:</strong>
                </p>
                <p>2.1 Kolačići prve strane</p>
                <p>
                    Ovu vrstu kolačića postavlja web stranica koju posjećujete i
                    samo ih ta web stranica može koristiti.
                </p>
                <p>2.2 Kolačići treće strane</p>
                <p>
                    Ove kolačiće postavlja neko drugi, a ne vlasnik web stranice
                    koju posjećujete. Portal može sadržavati sadržaje drugih
                    stranica koji mogu postaviti svoje kolačiće. Također, ako
                    podijelite link na portalu Dzobs, usluga na kojoj ga
                    dijelite (na primjer, Facebook) može postaviti kolačić u
                    vašem pregledniku. Nemamo kontrolu nad kolačićima treće
                    strane - možete ih isključiti ali ne putem nas.
                </p>
                <p>2.3 Kolačići sesije</p>
                <p>
                    Ovi kolačići traju samo onoliko dugo koliko traje vaša
                    mrežna sesija i nestaju s vašeg računala ili uređaja
                    prilikom zatvaranja preglednika.
                </p>
                <p>2.4 Trajni kolačići</p>
                <p>
                    Ovi kolačići ostaju na vašem računalu ili uređaju i nakon
                    što zatvorite preglednik, a traju onoliko vremena koliko je
                    određeno u kolačiću. Upotrebljavajmo trajne kolačiće kada
                    trebamo znati tko ste duže od jedne sesije pregledavanja. Na
                    primjer, upotrebljavamo ih kako bi se sjetili vaših postavki
                    i sljedeći put kada nas posjetite.
                </p>
                <p>2.5 Neophodni kolačići</p>
                <p>
                    Ovi kolačići omogućuju vam korištenje različitih dijelova
                    portala. Bez njih vam ne možemo pružiti usluge koje ste
                    tražili. Neki primjeri kako upotrebljavamo ove kolačiće su:
                    kada se prijavite na portal, da bismo se sjetili stvari koje
                    ste već učinili, na primjer - teksta koji ste unijeli u
                    obrazac za registraciju, kako bi te informacije i dalje bile
                    učitane kada se vratite na stranicu. Ova vrsta kolačića nam
                    također pomaže da memoriramo sigurnosne postavke koje utiču
                    na pristup određenom sadržaju. Ukoliko podesite vaš
                    preglednik tako da blokirate ovu vrstu kolačića, određene
                    funkcije i usluge neće funkcionisati u odnosu na vas.
                </p>
                <p>2.6 Funkcionalni kolačići</p>
                <p>
                    Oni nam pomažu da prilagodimo portal, sjećajući se vaših
                    preferencija i postavki. Na primjer, da se sjetimo vašeg
                    omiljenog sadržaja, da vam ne prikazujemo iste poruke koje
                    se odnose samo na nove posjetitelje ili da se sjetimo nekih
                    drugih postavki.
                </p>
                <p>2.7 Kolačići izvedbe</p>
                <p>
                    Ova vrsta kolačića nam pomaže da razumijemo kako
                    posjetitelji koriste portal, kako bismo se mogli poboljšati.
                    Oni nam pomažu da isprobavamo različite ideje. Ponekad
                    koristimo i kolačiće drugih kompanija (npr. kolačiće Google
                    Analytics) radi analize kako posjetioci koriste portal. Neki
                    primjeri kako upotrebljavamo ove kolačiće su: prikupljanje
                    podataka o najčešćim posjetiteljima portala, kako bismo
                    mogli poboljšati naše online usluge ili kako bismo se
                    pobrinuli da web-lokacija ispravno funkcionira i da
                    popravlja sve eventualne pogreške, kako bi poboljšali izgled
                    i dojam portala. Kolačići izvedbe se također koriste radi
                    prikupljanja informacije o tome koji dijelovi naše web
                    stranice su najposjećeniji i od koje vrste korisnika.
                </p>
                <p>2.8 Kolačići za oglašavanje</p>
                <p>
                    Radi se o kolačićima koje upotrebljavamo kako bi vam,
                    prilikom posjete portala, mogli prikazati posebno ciljane
                    oglase, ovisno o vašim preferencijama. Koristimo i mreže za
                    oglašavanje koje mogu pratiti vaše pregledavanje na
                    različitim web lokacijama. Primjera radi, ukoliko često
                    pregledate članke o razvoju softvera, ova vrsta kolačića
                    prikuplja informacije o vašim posjetima našoj web stranici,
                    sadržaju koji pregledate, linkovima koje ste koristili, kao
                    i informacije o vašem pregledniku, uređaju i IP adresi.
                </p>
                <p>
                    <strong>3. Koliko dugo traju kolačići?</strong>
                </p>
                <p>
                    Neki kolačići se brišu kada zatvorite preglednik na svojoj
                    web-lokaciji ili aplikaciji. Drugi ostaju duže, ponekad
                    trajno, i spremljeni su na vaš uređaj pa su tamo i kada ga
                    ponovo koristite.
                </p>
                <p>
                    <strong>
                        4. Kako mogu kontrolisati svoje kolačiće i praćenje?
                    </strong>
                </p>
                <p>
                    Kada nas prvi put posjetite, obavijestićemo vas o našim
                    kolačićima.
                </p>
                <p>
                    Vaš preglednik ili uređaj mogu sadržavati postavke koje vam
                    omogućuju da odaberete hoće li se kolačići spremati u
                    pregledniku, te mogućnosti brisanja kolačića. Dodatne
                    informacije o tim kontrolama potražite na stranicama
                    vlasnika preglednika ili uređaja. Imajte na umu da, ako
                    onemogućite upotrebu kolačića u pregledniku, to može značiti
                    da ne možete pristupiti nekim uslugama portala ili da neki
                    dio stranice neće ispravno ili u punom obimu raditi za vas.
                    Primjera radi, isključivanjem kolačića za oglašavanje
                    reducirat ćete broj oglasa prilagođen za vas, iako će se na
                    vašem pregledniku i dalje prikazivati marketinški materijal,
                    dijelom prema vašim preferencijama, a dijelom u općem obimu
                    marketinga namijenjenog za sve posjetioce portala.
                </p>
                <p>
                    Također postoje i alati trećih strana putem kojih možete
                    blokirati kolačiće.
                </p>
                <p>
                    <strong>
                        5. Kako ću saznati o izmjenama ovih pravila?
                    </strong>
                </p>
                <p>
                    Ponekad ažuriramo svoja pravila koja se tiču upotrebe
                    kolačića i zaštite osobnih podataka. Ako napravimo važne
                    izmjene, na primjer o tome kako upotrebljavamo vaše osobne
                    podatke, obavijestićemo vas. To može biti obavijest,
                    elektronička pošta ili poruka u vašoj aplikaciji.
                </p>
                <p>
                    <strong>6. Kako mogu kontaktirati Dzobs?</strong>
                </p>
                <p>Saznajte više i kontaktirajte nas o svojim pravima:</p>
                <ul>
                    <li>putem e-pošte: info@dzobs.com</li>
                    <li>
                        poštom: Računarsko programiranje "Dzobs.com" Nikola
                        Novaković s.p. Banja Luka.
                    </li>
                </ul>
                <p>
                    <em>Poslednja izmjena</em> <strong>9. februar 2022.</strong>
                </p>
            </article>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
